<template>
  <div class="hkl-input-points">
    <HKLInputNumber
      v-if="isEdit"
      v-model="proxyValue"
      v-bind="$attrs"
      v-on="$listeners"
      v-fusioninputcheck="{
        type: 'string',
        pattern: pointFusionInputCheckPattern,
        required: proxyValue,
        showTip: false,
      }"
    />
    <HKLText
      v-else
      :text="proxyValue || $t('emptyValue')"
    />
    <HKLText :text="$t('tenancy.greenOperation.assessments.points')" />
  </div>
</template>

<script>
import { computed } from 'vue-demi'
import HKLText from '@/controls/HKLText.vue'
import HKLInputNumber, { onKeyPressValidation } from './HKLInputNumber.vue'

const SOURCE = '_value'
const EVENT = '_change'

export default {
  components: {
    HKLText,
    HKLInputNumber,
  },
  model: {
    prop: SOURCE,
    event: EVENT,
  },
  props: {
    [SOURCE]: {
      type: [String, Number],
    },
    isEdit: {
      type: Boolean,
      default: () => false,
    },
  },
  setup (props, { emit }) {
    const proxyValue = computed({
      get () { return props[SOURCE] },
      set (val) { emit(EVENT, val) },
    })
    return {
      proxyValue,
      pointFusionInputCheckPattern: onKeyPressValidation,
    }
  },
}
</script>

<style lang="scss" scoped>
$componentHeight: 30px;

.hkl-input-points {
  display: flex;
  flex-direction: row;
  align-items: baseline;
  height: $componentHeight;
  input {
    height: $componentHeight;
    width: 100px;
  }
}
.hkl-text {
  line-height: $componentHeight;
}
* + .hkl-text {
  margin-left: 5px;
}
input .hkl-text {
  font-size: 12px;
}
</style>
